import React from 'react'
import i18n from '@pureartisan/simple-i18n'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  Typography,
  useTheme,
} from '@material-ui/core'
import clsx from 'clsx'

// Styles for component.
const useGeoChipStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}))

const GeoChip = ({
  id,
  text,
  innerText,
  border,
  fill,
  className,
  clickHandler,
  width = 12,
  height = 12,
}) => {
  // console.log({ color })
  const classes = useGeoChipStyles()

  const handleClick = () => clickHandler && clickHandler(id)
  return (
    <Box
      display={'flex'}
      className={clsx(classes.root, className, 'geoChip')}
      onClick={handleClick}
    >
      <Box
        className={clsx('geo-icon')}
        sx={{
          width,
          height,
          border: `1.5px solid ${border}`,
          background: !!fill ? fill : 'none',
          borderRadius: 3,
          mr: 1,
          // display: 'flex',
          // boxSizing: 'border-box',
        }}
      >
        <Typography
          align="center"
          variant="caption"
          className="geo-name"
          display="block"
          style={{ lineHeight: height + 'px' }}
        >
          {innerText}
        </Typography>
      </Box>
      <Typography
        // align="center"
        variant="body1"
        className="geo-name"
        // display="block"
        // style={{ lineHeight: height + 'px' }}
      >
        {text}
      </Typography>
    </Box>
  )
}

GeoChip.propTypes = {}

GeoChip.defaultProps = {}

export default GeoChip
